import axios from 'axios';

const ENV = {
  TESTING: 'http://localhost:5002/api',
  PRODUCTION: '/api'
};

// Function to detect the current environment
const detectEnvironment = () => {
  // Check if we're running in a production environment
  if (window.location.hostname !== 'localhost' && 
      !window.location.hostname.includes('127.0.0.1') &&
      !window.location.hostname.includes('.local')) {
    return 'PRODUCTION';
  }
  
  return 'TESTING';
};

// Dynamically set the environment based on the current URL
const CURRENT_ENV = detectEnvironment();

const api = axios.create({
  baseURL: ENV[CURRENT_ENV],
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);

export default api;
